<template>
  <div>
    <b-row class="row-padding">
      <b-col sm="4">
        <Label>% MVA:</Label>
        <InputQuantity
          ref="pMVAST"
          id="pMVAST"
          :precision="4"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pMVAST"
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vICMSST"
          id="vICMSST"
          label="Valor ICMS-ST:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vICMSST"
          :error="$v.productOfPurchaseOnFiscalEdit.fiscal.values.vICMSST.$error"
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vBCST"
          id="vBCST"
          label="Valor Base Calc ICMS-ST:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vBCST"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col
        sm="4"
        v-if="valorUS(productOfPurchaseOnFiscalEdit.fiscal.values.pST) > 0"
      >
        <Label>% Aliquota ICMS-ST Destino:</Label>
        <InputQuantity
          ref="pST"
          id="pST"
          :precision="4"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pST"
        />
      </b-col>
      <b-col sm="4" v-else>
        <Label>% Aliquota ICMS-ST Destino:</Label>
        <InputQuantity
          ref="pICMSST"
          id="pICMSST"
          :precision="4"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pICMSST"
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vICMSSTRet"
          id="vICMSSTRet"
          label="Valor ICMS-ST Retido:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vICMSSTRet"
          :error="
            $v.productOfPurchaseOnFiscalEdit.fiscal.values.vICMSSTRet.$error
          "
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vBCSTRet"
          id="vBCSTRet"
          label="Valor BC ICMS-ST Retido:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vBCSTRet"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col sm="4">
        <Label>% FCP ST:</Label>
        <InputQuantity
          ref="pFCPST"
          id="pFCPST"
          :precision="4"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.pFCPST"
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vFCPST"
          id="vFCPST"
          label="Valor FCP ST:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vFCPST"
          :error="$v.productOfPurchaseOnFiscalEdit.fiscal.values.vFCPST.$error"
        />
      </b-col>
      <b-col sm="4">
        <InputMoney
          ref="vBCFCPST"
          id="vBCFCPST"
          label="Valor BC FCP ST:"
          inputClass="form-control input"
          labelBold
          :precision="2"
          v-model="productOfPurchaseOnFiscalEdit.fiscal.values.vBCFCPST"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputMoney, InputQuantity, Label } from '@/components/Form';
import FormatMixin from '../../../../../../../Application/mixins/FormatMixin';
import {
  isValidICMSST,
  isValidICMSSTRetido,
  isValidFCPST,
} from '../validations';

export default {
  name: 'stTab',
  mixins: [FormatMixin],
  components: {
    InputMoney,
    InputQuantity,
    Label,
  },
  validations: {
    productOfPurchaseOnFiscalEdit: {
      fiscal: {
        values: {
          vICMSST: { isValidICMSST },
          vICMSSTRet: { isValidICMSSTRetido },
          vFCPST: { isValidFCPST },
        },
      },
    },
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
  },
  watch: {
    productOfPurchaseOnFiscalEdit: {
      handler() {},
      deep: true,
    },
  },
};
</script>
